import { render } from "./update.vue?vue&type=template&id=074cf760"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"

import "./update.vue?vue&type=style&index=0&id=074cf760&lang=css"

import exportComponent from "C:\\projeto\\dynamik\\dynamik_adm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__